import Cookies from 'js-cookie';
import {Options} from './Options.js';

let Status = {
  visited: Cookies.get('visited') ? true : false,
  domain: document.domain,
  page: document.querySelector('[data-barba="container"]') ? document.querySelector('[data-barba="container"]').getAttribute('data-barba-namespace') : document.body.getAttribute('data-page'),
  url: document.URL,
  winWidth: window.innerWidth,
  winHeight: window.innerHeight,
  docWidth: document.body.clientWidth,
  docHeight: document.body.clientHeight,
  scrollY: window.pageYOffset,
  scrollCurrent: 0,
  scrollRate: 0,
  viewport: document.querySelector('meta[name="viewport"]').getAttribute('content'),
  ua: navigator.userAgent.toLowerCase(),
  entry: performance.getEntriesByType("navigation")[0].type,
  referrer: document.referrer ? new URL(document.referrer) : null,
  isDesktop     : true,
  isTablet      : false,
  isMobile      : false,
  isFirst       : true,
  animationFrame: null,
}


Status.isIos = Status.ua.indexOf('iphone') > -1 || Status.ua.indexOf('ipad') > -1 || Status.ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
Status.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
Status.isLocal = Status.url.indexOf('localhost') > -1;
Status.isStage = Status.url.indexOf('testing-web') > -1;

Status.assets = document.getElementById('js-scripts').src.slice(0,document.getElementById('js-scripts').src.indexOf('assets/')-1);

const UpdateStatus = {
  load() {
    Status.winWidth = window.innerWidth;
    Status.winHeight = window.innerHeight;
    Status.docWidth = document.body.clientWidth;
    Status.docHeight = document.body.clientHeight;
    Status.scrollY = window.pageYOffset;
    Status.scrollCurrent = Status.scrollY;
    Status.scrollRate = 0;
  },
  resize() {
    Status.winWidth = window.innerWidth;
    Status.winHeight = window.innerHeight;
    Status.docWidth = document.body.clientWidth;
    Status.docHeight = document.body.clientHeight;
    Status.ua = navigator.userAgent.toLowerCase();
    Status.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  scroll() {
    Status.scrollY = window.pageYOffset;
    Status.scrollRate = Status.scrollY - Status.scrollCurrent;
    Status.scrollCurrent = Status.scrollY;
  },
}

const CheckDevice = () => {
  const classList = {
    ios: 'is-ios',
    sp: 'is-sp',
    tb: 'is-tb',
    pc: 'is-pc',
    touch: 'is-touch',
  };
  if ( Status.ua.indexOf('ipad') > -1 || 
      Status.ua.indexOf('iphone') > -1 || 
      (Status.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
  ) {
    document.body.classList.add(classList.ios);
    Status.isIos = true;
  } else {
    document.body.classList.remove(classList.ios);
    Status.isIos = false;
  }

  if('ontouchstart' in window || navigator.maxTouchPoints) {
    document.body.classList.add(classList.touch);
    Status.isTouch = true;
  } else {
    document.body.classList.remove(classList.touch);
    Status.isTouch = false;
  }

  if (
    Status.ua.indexOf('iphone') > -1 ||
    Status.ua.indexOf('ipod') > -1 ||
    Status.ua.indexOf('android') > -1 && Status.ua.indexOf('mobile') > -1
  ) {
    Status.isDesktop = false;
    Status.isTablet = false;
    Status.isMobile = true;
    document.body.classList.remove(classList.tb,classList.pc);
    document.body.classList.add(classList.sp);
    // if( Status.winWidth < Options.breakpoint.min ) {
    //   document.querySelector('meta[name="viewport"]').setAttribute('content', `width=${Options.breakpoint.min}, initial-scale=1, maximum-scale=2, user-scalable=yes`);
    // } else {
    //   document.querySelector('meta[name="viewport"]').setAttribute('content', Status.viewport);
    // }
  } else if (
    Status.ua.indexOf('ipad') > -1 ||
    Status.ua.indexOf('Android') > -1 ||
    (Status.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
  ) {
    Status.isDesktop = false;
    Status.isTablet = true;
    Status.isMobile = false;
    document.body.classList.remove(classList.pc,classList.sp);
    document.body.classList.add(classList.tb);
    if( Status.tabletView !== false && typeof Status.tabletView === 'number' ){
      document.querySelector('meta[name="viewport"]').setAttribute('content', `width=${Status.tabletView}, initial-scale=1, maximum-scale=2, user-scalable=yes`);
    }
  } else {
    Status.isDesktop = true;
    Status.isTablet = false;
    Status.isMobile = false;
    document.body.classList.remove(classList.tb,classList.sp);
    document.body.classList.add(classList.pc);
  }
}

export {Status, UpdateStatus, CheckDevice};